<template>
  <div>
    <el-form ref="form" :model="formData" size="small">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.shipment_customs_code_hscode') || '报关HSCODE'"
          >
            <HscodeSelect
              :hscode="formData.hscode"
              @change="onHscodeChange"
              :categoryCode="masterCategoryCode"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.form_label_hscodeName') || '报关中文名称'"
          >
            <el-input
              v-model="formData.hscodeName"
              :placeholder="
                $l('INDEX.form_placeholder_hscode') || '请选择报关HSCODE'
              "
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.form_label_hscodeNameEn') || '报关英文名称'"
          >
            <el-input
              v-model="formData.hscodeNameEn"
              :placeholder="
                $l('INDEX.form_placeholder_hscode') || '请选择报关HSCODE'
              "
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="mini">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="mini">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="mini">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import HscodeSelect from '../../hscode-select'
export default {
  mixins: [EditLoading],
  components: { HscodeSelect },
  props: {
    listGoodsSpec: { type: Array, default: () => {} },
    shipmentCode: { type: String, default: '' },
    masterCategoryCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const firstGoodsSpec = this.listGoodsSpec[0]
      const { hscode, hscodeName, hscodeNameEn } = firstGoodsSpec
      this.formData = { hscode, hscodeName, hscodeNameEn }
    },
    onHscodeChange(e) {
      const { hscode = '', hscodeName = '', hscodeNameEn = '' } = e || {}
      this.formData.hscode = hscode
      this.formData.hscodeName = hscodeName
      this.formData.hscodeNameEn = hscodeNameEn
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const listCode = this.listGoodsSpec.map((item) => item.orderGoodsSpecCode)
      const params = { ...this.formData, listCode }
      this.$emit('confirm', params)
      this.close()
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
